import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { grpc } from '@improbable-eng/grpc-web';
import { CommonService } from './common.service';
import { AuthSessionService } from './auth-session.service';
import { Components, Modules } from '../constants/constants';

/** Read by BusinessModules (AiVideoCreativeGrpcService); WebAggregator forwards request headers unchanged. */
const CLIENT_TIMEZONE_HEADER = 'x-client-timezone';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor(private router: Router,
    private commonService: CommonService,
    private authSessionService: AuthSessionService
  ) { }

  getMetaData() {
    var metadata: grpc.Metadata;
    metadata = new grpc.Metadata();
    metadata.set('accesstoken', this.getAccessToken());
    // The browser's IANA timezone, which the backend maps to a country for region-gated features
    // (e.g. the AI Video model picker). A hint only; never trusted for anything a user could abuse.
    const timeZone: string = this.getClientTimeZone();
    if (timeZone) {
      metadata.set(CLIENT_TIMEZONE_HEADER, timeZone);
    }
    return metadata;
  }

  private getClientTimeZone(): string {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone ?? '';
    } catch {
      return '';
    }
  }
  
 getAccessToken(){
    var token : any = this.authSessionService.getToken();
  if(token==undefined || token==null){
    this.authSessionService.clearToken();
    localStorage.clear();
    this.commonService.closeSignalRHub();

    if(this.router.url.includes(Modules.Settings) && this.router.url.includes(Components.BillingPlan)){
      let queryParams = { redirect_url: Components.BillingPlan };
      this.router.navigate(['/login'], {queryParams: queryParams});
    }
    else{
      this.router.navigate(['/login']);
    }
  }
  return token;
}


}
